import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Popup from './Popup'
import React from 'react'

interface ActivateAccountPopupProps {
  link: string
}

const ActivateAccountPopup: React.FC<ActivateAccountPopupProps> = ({ link }) => {
  const { t } = useTranslation('payment')
  const { replace } = useHistory()

  return (
    <Popup centered>
      <div className='activateAccount__popup'>
        <div className='popup__title'>
          <i className='icon icon--logo' />
          <div>{t('doYouWantToActivateYourAccount')}</div>
          <div>{t('manageYourRentalConveniently')}</div>
        </div>
        <div className='popup__buttons'>
          <ArrowBtn
            enlarged
            text={t('activate')}
            action={() => {
              replace(link)
            }}
          />
          <BackBtn
            text={t('stayOffline')}
            action={() => {
              replace('/')
            }}
          />
        </div>
      </div>
    </Popup>
  )
}

export default ActivateAccountPopup